module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightlightrain-addc746c3ad0069e69a49105057aa3ea.webp";